import { ToUAuthPages } from './../../../shared/guards/to-atuthPages.guard';
import { CheckoutGuard } from './../../../shared/guards/checkout.guard';
import { ToUsersittingGuard } from './../../../shared/guards/to-usersitting.guard';
import { BrowserOnlyGuard } from '../../../shared/guards/browserOnly.guard'
import { NgModule } from '@angular/core';
import { NoPreloading, RouterModule, Routes } from '@angular/router';
import { NavFooterLayoutComponent } from './layout/components/nav-footer-layout/nav-footer-layout.component';
import { FullContentLayoutComponent } from './layout/components/full-content-layout/full-content-layout.component';


const routes: Routes = [{
  path: ':lang/auth',
  canLoad: [BrowserOnlyGuard],
  component: FullContentLayoutComponent,
  children: [
    {
      path: '',
      loadChildren: () =>
        import(`./modules/auth/auth.module`).then((m) => m.AuthModule),
    },
  ],
},
{
  path: ':lang',
  component: NavFooterLayoutComponent,
  children: [
    {
      path: '',
      loadChildren: () =>
        import('./modules/home/home.module').then((m) => m.HomeModule),
    },
    {
      path: 'order/delivery/:deliveryHash',
      loadComponent: () => import('../app/components/delivery-approve/delivery-approve.component').then(c => c.DeliveryApproveComponent)
    },
    {
      path: 'settings',
      canLoad: [BrowserOnlyGuard],
      canActivate: [ToUsersittingGuard],
      loadChildren: () =>
        import('./modules/user-settings/user-settings.module').then(
          (m) => m.UserSettingsModule
        ),

    },
    {
      path: 'quick-links',
      loadChildren: () =>
        import('./components/footer/footer.module').then(
          (m) => m.FooterModule
        ),
    },
    {
      path: 'categories',
      loadChildren: () =>
        import('./modules/categories/categories.module').then(
          (m) => m.CategoriesModule
        ),
    },
    {
      path: 'checkout',
      canLoad: [BrowserOnlyGuard],
      canActivate: [ToUsersittingGuard, CheckoutGuard],
      loadChildren: () =>
        import('./modules/checkout/checkout.module').then(
          (m) => m.CheckoutModule
        ),
    },
    {
      path: 'blogs',
      loadChildren: () =>
        import('./components/footer/blogs/blogs.module').then(
          (m) => m.BlogsModule
        ),
    },
    { 
      path: '404', 
      loadComponent: () => import('./layout/not-found/components/not-found/not-found.component').then(c => c.NotFoundComponent) 
    },
    { 
      path: '**', 
      loadComponent: () => import('./layout/not-found/components/not-found/not-found.component').then(c => c.NotFoundComponent) 
    },
  ],
},

{ path: '', redirectTo: '/en', pathMatch: 'full' },
{
  path: '**', loadComponent: () => import('./layout/not-found/components/not-found/not-found.component').then(c => c.NotFoundComponent)
},
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: NoPreloading,
      initialNavigation: 'enabledBlocking',
      useHash: false,
      scrollPositionRestoration: 'enabled',
      anchorScrolling: 'enabled',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule { }
